module.exports = __webpack_public_path__ + "static/media/pod-offline.df94d192.svg";